<template>
  <div class="block">
    <dialog-component
      :dialogVisible.sync="deviceDialogVisible"
      @dialogClose="close"
      :dialog-title="title"
      :closeClick="showClose"
      width="40vw">
      <div :style="logDetails(code)" slot="content" style="padding: 0 30px;">
        <div class="demo-input-suffix" style="margin-top: 40px; margin-left: 15%" v-if="code == '1' || code == '5'">
          <div>
            <span style="float: left;width: 20%">告警处理人：</span>
            <el-input v-model="handler" placeholder="请输入告警处理人" style="width: 70%"></el-input>
          </div>
          <div style="padding-top: 3%">
            <span style="float: left;width: 20%">告警处理建议：</span>
            <el-input type="textarea" :rows="3" v-model="proposal" placeholder="请输入告警处理建议"
                      style="width: 70%"></el-input>
          </div>
        </div>

        <div class="demo-input-suffix" style="margin-top: 40px; margin-left: 15%" v-if="code === '2' || code == '6'">
          <div>
            <span style="float: left;width: 15%">消警人：</span>
            <el-input v-model="eliminater" placeholder="请输入告警消警人" style="width: 70%"></el-input>
          </div>
          <div style="padding-top: 3%">
            <span style="float: left;width: 15%">消警建议：</span>
            <el-input type="textarea" :rows="3" v-model="proposal" placeholder="请输入消警建议" style="width: 70%"></el-input>
          </div>
        </div>
        <div v-if="code == '3'">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :icon="activity.icon"
              :type="activity.type"
              :color="activity.color"
              :size="activity.size"
              :timestamp="activity.timestamp"
              placement="top">
              <el-card>
                <div style="font-size: 1rem; font-weight: bold;color: #299FFB">{{ activity.content }}</div>
                <div style="font-size: 0.9rem; margin-top: 5px;">{{ activity.text }}</div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <div style="text-align: center;line-height: 40vh;" v-if="activities.length<=0">暂无数据</div>
        </div>

      </div>
      <div class="dialog-footer" slot="footer"
           style="text-align: center; margin-top: 100px; margin-bottom: 15px;">
        <el-button @touchstart="close" @click="close" v-if="code === '1' || code === '2' || code == '3' || code === '5' || code === '6'"
                   size="mini">关 闭
        </el-button>
        <el-button type="primary" v-if="code === '1' || code === '2' || code === '5' || code === '6'"
              @touchstart="preservation"     @click="preservation" size="mini">保 存
        </el-button>
      </div>

    </dialog-component>
  </div>
</template>

<script>

import {alarmElimination, alarmHandling, batchAlarmElimination, batchAlarmHandling} from '@/network/alarm-realtime';
import DialogComponent from "@/components/DialogComponent";
import {getAccountInfo} from "@/network/account";

export default {
  name: "AlarmHandling",
  props: ['visible', 'code', 'title', 'alarmId', 'idList', 'opinion', 'activities'],
  components: {DialogComponent},
  data() {
    return {
      deviceDialogVisible: false,
      proposal: '',
      showClose: false,
      handler: '',
      eliminater: '',
      accountName: '',
      account: {},
      accountDetail: {}
    }
  },
  watch: {
    visible(newVisible) {
      this.deviceDialogVisible = newVisible;
      this.proposal = this.opinion;
    }
  },
  mounted() {
    this.getAccountInfo()
  },
  methods: {
    close() {
      this.proposal = '';
      // this.$emit('refresh','');
      this.$emit('dialogClose', false);
      this.deviceDialogVisible = false;
    },
    preservation() {
      if (this.code === '1') {
        let params = {"id": this.alarmId, "confirmType": this.proposal, "operator": this.handler}
        console.log("告警处理参数：", params);
        alarmHandling(params).then(res => {
          if (res.code === 0) {
            if (res.data) {
              this.$message({
                message: '处理成功',
                type: 'success'
              });
            } else {
              this.$message.error('处理失败');
            }
          } else {
            this.$message.error('处理失败');
          }
          //关闭页面
          this.proposal = '';
          this.handler = this.accountName;
          //刷新实时告警数据
          this.$emit('refreshAlarmInformation', 'isConfirm');
          //刷新告警中心数据
          this.$emit('getData');
          this.close();
        });
      } else if (this.code === '2') {
        let params = {"id": this.alarmId, "operationTxt": this.proposal, "operator": this.eliminater}
        console.log("消警参数：", params);
        alarmElimination(params).then(res => {
          if (res.code === 0) {
            if (res.data) {
              this.$message({
                message: '消警成功',
                type: 'success'
              });
            } else {
              this.$message.error('消警失败');
            }
          } else {
            this.$message.error('消警失败');
          }
          //关闭页面
          this.proposal = '';
          this.eliminater = this.accountName;
          //刷新实时告警数据
          this.$emit('refreshAlarmInformation', 'isProcess');
          //刷新告警中心数据
          this.$emit('getData');
          this.close();
        });
      } else if (this.code === '5') {
        let params = {"idList": this.idList, "operationTxt": this.proposal, "operator": this.handler}
        console.log("批量告警处理参数：", params);
        batchAlarmHandling(params).then(res => {
          if (res.code === 0) {
            if (res.data) {
              this.$message({
                message: '批量处理成功',
                type: 'success'
              });
            } else {
              this.$message.error('批量处理失败');
            }
          } else {
            this.$message.error('批量处理失败');
          }

          //关闭页面
          this.proposal = '';
          this.handler = this.accountName;
          //刷新告警中心数据
          this.$emit('getData');
          this.close();
        });
      } else if (this.code === '6') {
        let params = {"idList": this.idList, "operationTxt": this.proposal, "operator": this.eliminater}
        console.log("批量消警参数：", params);
        batchAlarmElimination(params).then(res => {
          if (res.code === 0) {
            if (res.data) {
              this.$message({
                message: '批量消警成功',
                type: 'success'
              });
            } else {
              this.$message.error('批量消警失败');
            }
          } else {
            this.$message.error('批量消警失败');
          }
          //关闭页面
          this.proposal = '';
          this.eliminater = this.accountName;
          //刷新告警中心数据
          this.$emit('getData');
          this.close();
        });
      }
    },

    //查看日志
    logDetails(code) {
      if (code === '3') {
        let heigth = this.activities.length > 3 ? 560 : this.activities.length * 150;
        return `height: ` + heigth + `px; overflow-x:auto`;
      }
    },
    getAccountInfo() {
      getAccountInfo().then(res => {
        this.account = res.data.account
        this.accountDetail = res.data.accountDetail
        if (this.account.nickname) {
          this.accountName = this.account.nickname
          this.handler = this.account.nickname
          this.eliminater = this.account.nickname
        } else if (this.accountDetail.name) {
          this.accountName = this.accountDetail.name
          this.handler = this.accountDetail.name
          this.eliminater = this.accountDetail.name
        } else {
          this.accountName = this.account.code
          this.handler = this.account.code
          this.eliminater = this.account.code
        }
      })
    }
  }
}
</script>

<style scoped>
.logDetails {

}
</style>
